module.exports = __webpack_public_path__ + "static/media/YF09_0.bdb5f93d.jpg";